import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { MonitorService } from 'src/app/services/monitor/monitor.service';

/**
 * Returns true when the app is running inside an iframe.
 * Replaces MSAL Browser v2 `BrowserUtils.isInIframe()` (broken typing under msal-browser v3).
 */
function isAppInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  /**
   * constructor
   * @param authService 
   */
  constructor(private authService: MsalService, private monitorService:MonitorService) {
  }

  /**
   * on init
   */
  ngOnInit(): void {
    this.monitorService.logEvent('ngOnInit', [ 'LogoutComponent', 'addenda-quote' ]);
    this.authService.logoutRedirect({
      // If in iframe, dont perform redirect to AAD
      onRedirectNavigate: () => {
        return !isAppInIframe();
      }
    });
  }

}
